import React, { useState } from 'react';
import './Textarea.scss';
import { Editor } from '@tinymce/tinymce-react';

export type TextareaProps = {
    label?: string;
    placeholder?: string;
    name: string;
    value?: string;
    height?: number;
    required?: boolean;
    wysiwyg?: boolean;
    className?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement> | string) => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea: React.FC<TextareaProps> = ({
    label,
    placeholder,
    value,
    onChange,
    onBlur,
    className,
    required = false,
    height = 160,
    wysiwyg = false,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };

    return (
        <div
            className={`textarea-wrapper ${isFocused ? 'focused' : ''} ${value ? 'has-value' : ''} ${className} ${wysiwyg ? 'is-wysiwyg' : ''}`}
        >
            {label && (
                <label className="textarea-label">
                    {label} {required && <>*</>}
                </label>
            )}
            {wysiwyg ? (
                <div className="wysiwyg-wrapper">
                    <Editor
                        value={value}
                        apiKey="56zpn0n9vvxee54zmjk7hfsq7f5x1evkqw2v5lytiulo01zl"
                        init={{
                            height: height,
                            language: 'fr_FR',
                            toolbar_location: 'bottom',
                            menubar: false,
                            plugins: [
                                'advlist',
                                'autolink',
                                'lists',
                                'link',
                                'charmap',
                                'preview',
                                'anchor',
                                'searchreplace',
                                'visualblocks',
                                'code',
                                'fullscreen',
                                'insertdatetime',
                                'table'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic underline | link | alignleft aligncenter alignright alignjustify | table bullist numlist outdent indent | removeformat',
                            placeholder: placeholder,
                            content_style: 'body { background-color: transparent!important; }' // <-- Ajoute cette ligne
                        }}
                        onEditorChange={(content: string) => {
                            if (onChange) onChange(content);
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={handleBlur}
                    />
                </div>
            ) : (
                <>
                    <textarea
                        placeholder={placeholder}
                        style={{ height: height }}
                        value={value}
                        required={required}
                        onFocus={() => setIsFocused(true)}
                        onBlur={handleBlur}
                        onChange={onChange}
                        {...props}
                    />
                </>
            )}
        </div>
    );
};
